module.exports = __webpack_public_path__ + "media/old_images/default-site-activity-338f7247.png";